import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { newListRemoveItem } from '../newListRemoveItem';
import newListUndoItem from '../newListUndoItem';
import hasStorage from './hasStorage'; // This file wraps localStorage to make it behave like a REST API with
// get/post/put/delete methods so that it can be used in the exact same way
// as the API endpoint does for logged in users.

var makeLocalStorageRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var wishlist, methodType, body, items, wishlistItems, _items, filteredWishlist, _items2, localList, _filteredWishlist;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!config || !config.methodType)) {
              _context.next = 2;
              break;
            }

            throw new Error('There has been an error attempting to request your wishlist items');

          case 2:
            wishlist = hasStorage('localStorage') && localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : {
              wishlists: [{
                items: []
              }]
            };
            methodType = config.methodType, body = config.body;
            _context.t0 = methodType;
            _context.next = _context.t0 === 'get' ? 7 : _context.t0 === 'post' ? 8 : _context.t0 === 'delete' ? 13 : _context.t0 === 'put' ? 18 : 23;
            break;

          case 7:
            return _context.abrupt("return", wishlist);

          case 8:
            items = body.items;
            wishlistItems = wishlist.wishlists[0].items;
            items.forEach(function (obj) {
              if (wishlistItems.every(function (item) {
                return item.partNumber !== obj.partNumber;
              })) {
                wishlistItems.unshift({
                  partNumber: obj.partNumber,
                  hasVariant: obj.hasVariant
                });
              }
            });
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            return _context.abrupt("return", wishlist);

          case 13:
            _items = body.items;
            filteredWishlist = newListRemoveItem(wishlist.wishlists[0].items, _items.map(function (item) {
              return item.partNumber;
            }));
            wishlist.wishlists[0].items = filteredWishlist;
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            return _context.abrupt("return", wishlist);

          case 18:
            _items2 = body.items, localList = body.localList;
            _filteredWishlist = newListUndoItem(localList, _items2.map(function (item) {
              return item.partNumber;
            })).filter(function (item) {
              return !item.deleted;
            });
            wishlist.wishlists[0].items = _filteredWishlist;
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            return _context.abrupt("return", wishlist);

          case 23:
            return _context.abrupt("return", wishlist);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function makeLocalStorageRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default makeLocalStorageRequest;